import axios from 'axios'

export default {
  getFor: (cardId) => axios.get(`/api/paper-agreements`, { headers: {Accept: 'application/json'}, params: {cardId: cardId} }).then(response => response.data),
  getAgreement: (id) => axios.get(`/api/paper-agreements/${id}`).then(response => response.data),
  digitalize: (id, request) => axios.put(`/api/paper-agreements/${id}/digitalize`, request),
  update: (id, modified) => axios.patch(`/api/paper-agreements/${id}`, modified),
  add: agreement => axios.post(`/api/paper-agreements`, agreement).then(({data}) => data.id)
}
